import { render, staticRenderFns } from "./FeatureSection1.vue?vue&type=template&id=d75aaf3c&scoped=true"
import script from "./FeatureSection1.vue?vue&type=script&lang=js"
export * from "./FeatureSection1.vue?vue&type=script&lang=js"
import style0 from "./FeatureSection1.vue?vue&type=style&index=0&id=d75aaf3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d75aaf3c",
  null
  
)

export default component.exports